import { Inject } from '@nuxt/types/app';

let uid = 0;

export default (_, inject: Inject) => {
    const getUid = (name: string) => `uid-${uid++}-${name}`;
    inject('uid', getUid);
};
